import Lazy from "./lazy";
import LazyComponent from "./lazy-component";
import LazyContainer from "./lazy-container";
import LazyImage from "./lazy-image";
var Lazyload = {
  install: function install(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var LazyClass = Lazy();
    var lazy = new LazyClass(options);
    var lazyContainer = new LazyContainer({
      lazy: lazy
    });
    app.config.globalProperties.$Lazyload = lazy;

    if (options.lazyComponent) {
      app.component("LazyComponent", LazyComponent(lazy));
    }

    if (options.lazyImage) {
      app.component("LazyImage", LazyImage(lazy));
    }

    app.directive("lazy", {
      beforeMount: lazy.add.bind(lazy),
      updated: lazy.update.bind(lazy),
      unmounted: lazy.remove.bind(lazy)
    });
    app.directive("lazy-container", {
      beforeMount: lazyContainer.bind.bind(lazyContainer),
      updated: lazyContainer.update.bind(lazyContainer),
      unmounted: lazyContainer.unbind.bind(lazyContainer)
    });
  }
};
export { Lazyload };